__turbopack_context__.v({
  "selectWrapper": "K8oNJG_selectWrapper",
});
